import Box from '@mui/material/Box';
import { FC } from 'react';
import { OEILLERES } from '../domains/courses/services/enum';


interface Props {
    oeillere: OEILLERES | null;
    isSecondary?: boolean
}

export const OeillereBox: FC<Props> = ({ oeillere, isSecondary = false }) => {
    if (oeillere && oeillere !== OEILLERES.SANS_OEILLERES) {
        const icon = oeillere === OEILLERES.OEILLERES_CLASSIQUE ? '/classique.svg' : '/australienne.svg';

        const primary = 'brightness(0) saturate(100%) invert(12%) sepia(22%) saturate(1327%) hue-rotate(177deg) brightness(92%) contrast(98%)'
        const secondary = 'brightness(0) saturate(100%) invert(49%) sepia(51%) saturate(567%) hue-rotate(111deg) brightness(98%) contrast(94%)'
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="row"
                p={0}
            >
                <img
                    src={`${icon}`}
                    alt="oeillere"
                    style={{ height: '20px', width: '20px', marginBottom: '5px', filter: isSecondary ? secondary : primary, }}

                />
            </Box>
        );
    } else {
        return null;
    }
};
